import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DefaultButton, Panel, PrimaryButton, Stack, TextField} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";

function AddVentureCredentials(props) {
    const [user] = useContext(AuthContext);
    const [credentials, setCredentials] = useState('');

    const _submit = (e) => {
        e.preventDefault();
        const data = {credentials: credentials};
        fetch(`/api/venture/${props.add.venture_id}/credentials`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddVentureCredential'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        setCredentials(props.add.credentials || '');
    }, [props.add])


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Poświadczenia"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddVentureCredential'>
                <TextField required multiline autoFocus label='Poświadczenia' value={credentials} onChange={(e) => setCredentials(e.target.value || '')}/>
            </form>
        </Panel>
    )
}

export default AddVentureCredentials;